import * as Utils from '../../modules/Utils'

export default (data) => ({
  key: data.auditId,
  name: data.createdBy === 'Operations' ? 'Frontend Operations' : data.createdBy,
  date: Utils.dateToString(data.createdDate)
})



// WEBPACK FOOTER //
// ./src/api/audit/AuditTimelineModel.js